<script>
import { get } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import VueButton from "vue-button";

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueButton
  },
  data() {
    return {
      fullscreen: false,
      fullscreenEntered: false,
    };
  },
  methods: {
    mayRedirectInUrl(e) {
      const target = $(e.currentTarget);
      const urlSplitted = target.attr("href").split("#");
      const anchor = urlSplitted.length > 0 ? urlSplitted[1] : null;
      const url = urlSplitted[0].replace(/\/$/, "");
      
      if (anchor && window.location.pathname == url) {
        this.closeFullscreen();
        window.location.href = `#${anchor}`;
      } else {
        if (target.attr("target") == "_blank") {
          window.open(target.attr("href"), '_blank');
        } else {
          window.location.href = target.attr("href");
        }
      }
    
      return false;
    },
    getTarget: Fandom.getTarget,
    isItemActive(item) {
      // When url is a ContentLink extra field type the content name can be used as matching 
      // name when mathing name is missing. 
      if (item.url.content && !item.matching_name) {
        item.matching_name = item.url.content;
      }
      const re = new RegExp(`^(${item.matching_name})$`);
      return re.test(globalState.pageModel.main_content_name);
    },
    openFullScreenMenu() {
      this.fullscreen = true;
      disableBodyScroll(this.$el);
    },
    closeFullscreen() {
      this.fullscreenEntered = false;
      setTimeout(() => {
        this.fullscreen = false;
        clearAllBodyScrollLocks();
      }, 250);
    },
    toggleFullScreen() {
      if (this.fullscreen) {
        this.closeFullscreen();
      } else {
        this.openFullScreenMenu();
      }
    },
    afterEnterFullscreen() {
      this.fullscreenEntered = true;
    }
  },
  computed: { 
    logoUrl() {
      return get(this.pageModel, ["name_to_content", this.pageModel.main_content_name, "logo", "url"]) ||
            get(this.content, ["logo", "url"]);
    },
    landingUrl() {
      return get(this.pageModel, ["name_to_content", this.pageModel.main_content_name, "landing_url", "url"]) ||
             Fandom.applyContextToUrl("/");
    },
    items() {
      return this.content.navbar || []; 
    },
    logoAlt() {
      return get(this.pageModel, ['seo', 'title'], '');
    }
  },
};
</script>

<template>
  <nav class="navbar sticky-top" :class="items.length > 0 ? 'navbar-expand-md' : 'navbar-expand'" landing-header-component>
    <a class="navbar-brand p-0 ml-3 mr-0" :href="landingUrl">
      <h1 class="mb-0">
        <img :src="logoUrl" class="navbar-logo" :alt="logoAlt"/>
      </h1>
    </a>
    <div class="collapse navbar-collapse" id="navbar" :class="{'faded': fullscreen}">
      <ul class="navbar-nav ml-auto pr-3">
        <li 
          class="nav-item px-3 d-flex align-items-center" 
          v-for="(item, index) in items" 
          :class="{ 'active': isItemActive(item) }" 
          :key="`item-${index}`" 
          :id="`item-${index}`"
        >
          <a :href="item.url.url" @click.prevent="mayRedirectInUrl($event)">
            {{item.url.title}}
          </a>
        </li>
        <li>
          <vue-button
            tag="a"
            v-if="content.landing_button"
            :button="content.landing_button"
            buttonClass="btn btn-light btn-small-text py-2 px-3 ml-3"
          ></vue-button>
        </li>
      </ul>
    </div>
    <div class="d-md-none" v-if="content.only_landing_button_mobile">
      <vue-button
        tag="a"
        v-if="content.landing_button"
        :button="content.landing_button"
        buttonClass="btn btn-light btn-small-text py-2 px-3 ml-3"
      ></vue-button>
    </div>
    <div class="d-flex align-items-center d-md-none" v-if="items.length > 0 && !content.only_landing_button_mobile">
      <div id="nav-icon1" class="mr-3" :class="{'open': fullscreen}" @click="toggleFullScreen()">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <transition enter-active-class="animated slideInDown faster delay-05s" leave-active-class="animated slideOutUp faster" v-on:after-enter="afterEnterFullscreen">
      <div class="position-fixed-center bg-dark d-flex flex-column justify-content-between pb-5" v-if="fullscreen && items.length > 0">
        <ul class="navbar-nav text-center w-100 pt-5" :class="{'border-top': fullscreenEntered}">
          <li 
            class="nav-item py-4 text-center" 
            v-for="(item, index) in items" 
            :class="{ 'active': isItemActive(item) }" 
            :key="`item-${index}`" 
            :id="`item-${index}`"
          >
            <a :href="item.url.url" @click.prevent="mayRedirectInUrl($event)">
              {{item.url.title}}
            </a>
          </li>
        </ul>
        <div class="d-flex w-100 justify-content-center">
          <vue-button
            tag="a"
            v-if="content.landing_button"
            :button="content.landing_button"
            buttonClass="btn btn-light small py-3 px-4"
          ></vue-button>
        </div>
      </div>
    </transition>
  </nav>
</template>

<style lang="scss">
[landing-header-component] {

  & {
    background-color: $header-bg-dark;
    height: $header-height-sm;
  }

  .border-top {
    border-color: $gray-500;
  }

  .position-fixed-center {
    position: fixed;
    padding-top: $header-height-sm !important;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .animated.delay-05s {
    animation-delay: .5s;
  }

  .btn-small-text {
    font-size: .625rem;
  }

  #navbar {
    opacity: 1;
    transition: all .5s;
  }

  #navbar.faded {
    opacity: 0;
  }

  .navbar-nav {
    transition: all .25s;
  }

  .nav-item {
    text-transform: uppercase;
    font-size: .75rem !important;
    letter-spacing: 1px;

    a {
      color: $gray-300;
      text-decoration: none;
      transition: color .25s;
      font-weight: bold;
    }

    &:hover,
    &:active,
    &:focus,
    &.active {
      a {
        color: $white;
      }
    }

    @include media-breakpoint-down(sm) {
      font-size: 1rem !important;
    }
  }

  .navbar-logo {
    height: 35px;
  }

  /* Haburger css */

  #nav-icon1 {
    z-index: 1000000;
    width: 1rem;
    height: .75rem;
    position: relative;
    transform: rotate(0deg) .5s ease-in-out;
    cursor: pointer;
  }

  #nav-icon1:hover span {
    background-color: $gray-400;
  }

  #nav-icon1 span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: $white;
    opacity: 1;
    left: 0;
    transition: all .25s ease-in-out;
    transform: rotate(0deg) .25s ease-in-out;
  }

  #nav-icon1 span:nth-child(1) {
    top: 0px;
  }

  #nav-icon1 span:nth-child(2) {
    top: 5px;
  }

  #nav-icon1 span:nth-child(3) {
    top: 10px;
  }

  #nav-icon1.open span:nth-child(1) {
    top: 5px;
    transform: rotate(135deg);
  }

  #nav-icon1.open span:nth-child(2) {
    opacity: 0;
    left: -1rem;
  }

  #nav-icon1.open span:nth-child(3) {
    top: 5px;
    transform: rotate(-135deg);
  }
  
}
</style>
